import React from 'react';
import { FaClipboardList, FaFileAlt, FaRocket } from 'react-icons/fa';

const ComoTrabalho = () => {
  const passos = [
    {
      numero: '01',
      icon: <FaClipboardList className="text-3xl" />,
      titulo: 'Conversa inicial',
      descricao: 'Conversamos sobre suas necessidades, objetivos e expectativas para entender perfeitamente o que você precisa.',
    },
    {
      numero: '02',
      icon: <FaFileAlt className="text-3xl" />,
      titulo: 'Proposta personalizada',
      descricao: 'Elaboro uma proposta detalhada com escopo, prazos e investimento, alinhada com suas expectativas.',
    },
    {
      numero: '03',
      icon: <FaRocket className="text-3xl" />,
      titulo: 'Entrega e suporte',
      descricao: 'Desenvolvo seu projeto com qualidade, seguindo prazos e mantendo você informado em cada etapa.',
    },
  ];

  return (
    <section id="comoTrabalho" className="py-32 bg-dark-bg dark:bg-black text-cream relative overflow-hidden transition-colors duration-500">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-burnt/20 rounded-full blur-[150px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 gsap-reveal">
          <p className="text-burnt font-heading font-semibold uppercase tracking-wider text-sm mb-4">
            Processo
          </p>
          <h2 className="text-4xl md:text-5xl font-heading font-bold mb-4">
            Três passos para sua sede digital
          </h2>
          <p className="text-xl text-cream/70 max-w-2xl mx-auto font-body">
            Processo simples, transparente e focado no seu resultado
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {passos.map((passo, index) => (
            <div key={index} className="gsap-reveal relative text-center group">
              <div className="mb-6 flex justify-center">
                <div className="relative">
                  <div className="absolute inset-0 bg-burnt/30 rounded-full blur-xl group-hover:blur-2xl transition-all duration-500" />
                  <div className="relative bg-burnt text-white p-6 rounded-2xl group-hover:scale-110 transition-transform duration-300">
                    {passo.icon}
                  </div>
                </div>
              </div>
              <div className="mb-4">
                <span className="text-5xl font-heading font-bold text-burnt/40">{passo.numero}</span>
              </div>
              <h3 className="text-2xl font-heading font-semibold text-white mb-3">
                {passo.titulo}
              </h3>
              <p className="text-cream/70 leading-relaxed font-body">
                {passo.descricao}
              </p>
              {index < passos.length - 1 && (
                <div className="hidden md:block absolute top-16 left-[calc(50%+60px)] w-[calc(100%-120px)] h-px bg-gradient-to-r from-burnt/50 to-transparent" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComoTrabalho;
